/**
 * API クライアント (Worker /api/* を呼び出す)
 * 開発時: vite proxy 経由で localhost:8787 へ
 * 本番時: 同一オリジン (sim.splight.co.jp/api) または *.workers.dev
 */

// 開発時(localhost): Vite proxyで /api → Worker (localhost:8787)
// 本番(*.pages.dev / sim.splight.co.jp): Pages Functions が /api/* を Worker にプロキシ
//   → 同一オリジンなので CORS不要、Cloudflare Access ヘッダもそのまま伝播
const BASE = '/api';

async function request(method, path, body) {
  const res = await fetch(BASE + path, {
    method,
    headers: { 'Content-Type': 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
    credentials: 'include',
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw Object.assign(new Error(err.error || `HTTP ${res.status}`), { status: res.status, code: err.code });
  }
  return res.json();
}

export const api = {
  health: () => request('GET', '/system/health'),
  version: () => request('GET', '/system/version'),
  me: () => request('GET', '/auth/me'),
  updateMe: (data) => request('PATCH', '/auth/me', data),
  simulateHome: (data) => request('POST', '/simulate/home', data),
  simulateIndustry: (data) => request('POST', '/simulate/industry', data),
  simulateCorporate: (data) => request('POST', '/simulate/corporate', data),
  modelCases: () => request('GET', '/simulate/model-cases'),
  powerPlans: (company) => request('GET', '/simulate/power-plans' + (company ? '?company=' + encodeURIComponent(company) : '')),
  diagnoses: (limit, offset) => request('GET', `/diagnoses?limit=${limit || 20}&offset=${offset || 0}`),
  diagnosis: (id) => request('GET', '/diagnoses/' + id),
  saveDiagnosis: (data) => request('POST', '/diagnoses', data),
  deleteDiagnosis: (id) => request('DELETE', '/diagnoses/' + id),
  subsidies: (mode, region) => {
    const q = new URLSearchParams();
    if (mode) q.set('mode', mode);
    if (region) q.set('region', region);
    return request('GET', '/subsidies' + (q.toString() ? '?' + q : ''));
  },
  matchSubsidies: (data) => request('POST', '/subsidies/match', data),
  refreshSubsidies: (data) => request('POST', '/subsidies/refresh', data),
};
